import http from '@/lib/http';
import { cmsBlocksResolvedPropsPath } from '@/lib/routes';
import type { PageBlock } from '@/types/block';

interface ResolvedBlocksResponse {
  blocks: Array<{ id: string; props: Record<string, unknown> }>;
}

function serializeBlock(block: PageBlock): Record<string, unknown> {
  return {
    id: block.id,
    blockType: block.blockType,
    props: block.props ?? {},
    parentBlockId: block.parentBlockId ?? null,
    columnSpan: block.columnSpan,
    position: block.position,
    visible: block.visible,
  };
}

export async function resolveBlockProps(
  blocks: PageBlock[],
  pageId?: string,
  signal?: AbortSignal,
  sectionTemplateCode?: string,
): Promise<Map<string, Record<string, unknown>>> {
  const body: Record<string, unknown> = {
    blocks: blocks.map(serializeBlock),
    pageId,
  };
  if (sectionTemplateCode) {
    body.sectionTemplateCode = sectionTemplateCode;
  }

  const { data } = await http.post<ResolvedBlocksResponse>(
    cmsBlocksResolvedPropsPath(),
    body,
    signal ? { signal } : undefined,
  );

  return new Map(data.blocks.map((entry) => [entry.id, entry.props ?? {}] as const));
}
